import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";

const getForSearch = (params) => {
  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/GCC/Search", params);
};

const getApiById = (id) => {
  const params = {
    id,
  };
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/GCC/GetGccApiId",
    params
  );
};

const getApiAttachment = (id) => {
  const params = {
    id,
  };
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/GCC/GetGccApiAttachment",
    params
  );
};

const getByCaseId = (id) => {
  const params = {
    id,
  };

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/GCC/GetByCaseId",
    params
  );
};

const sendBack = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/GCC/SendBack?userId=" +
      userData.userId(),
    params
  );
};

const getComplaintGCClistlog = (id) => {
  const params = {
    id,
  };

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/GCC/GetComplaintGCClistlog",
    params
  );
}

export { getForSearch,getApiAttachment, getApiById, getByCaseId, sendBack, getComplaintGCClistlog };
